import { createFileRoute } from '@tanstack/react-router'
import PageClient from '~/features/sub-orders/config-profile/page-client'
import { Suspense } from 'react'

export const Route = createFileRoute('/_authed/staff/sub/config-profile')({
    component: () => <Suspense>
        <PageClient />
    </Suspense>,
})
